module.exports = "<md-icon class=material-icons ng-click=\"$ctrl.toggle(); $event.stopPropagation();\" md-svg-icon=\"{{ $ctrl.starredIcon }}\" aria-label=\"{{ ::$ctrl.starredAriaLabel }}\" aria-hidden=true> </md-icon> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/thing-star/thing-star.html
// module id = o+67
// module chunks = 1